/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type EstimateOrderQueryVariables = Types.Exact<{
	amount: Types.CurrencyAmountInput;
	assetId: Types.Scalars["ID"];
	price: Types.CurrencyAmountInput;
	fiatId: Types.Scalars["ID"];
	type?: Types.InputMaybe<Types.OrderType>;
	visionBonus?: Types.InputMaybe<Types.Scalars["Boolean"]>;
}>;

export type EstimateOrderQuery = {
	__typename?: "Query";
	estimateOrder: {
		__typename?: "EstimateOrderResponse";
		isFeeTransparent: boolean;
		userJourney: string;
		value: { __typename?: "CurrencyAmount"; value: string };
		feePercentage?: { __typename?: "FeePercentage"; value: string } | null;
		vsnFeeTokenCollection: {
			__typename?: "EstimateOrderVsnCollection";
			globalOptIn?: boolean | null;
			enabled: boolean;
			eligibleForVsn: boolean;
			feeDiscount: string;
			feeDiscountBefore?: string | null;
		};
	};
};

export const EstimateOrderDocument = gql`
	query estimateOrder(
		$amount: CurrencyAmountInput!
		$assetId: ID!
		$price: CurrencyAmountInput!
		$fiatId: ID!
		$type: OrderType
		$visionBonus: Boolean
	) {
		estimateOrder(
			amount: $amount
			price: $price
			assetId: $assetId
			fiatId: $fiatId
			type: $type
			visionBonus: $visionBonus
		) {
			value {
				value
			}
			feePercentage {
				value
			}
			isFeeTransparent
			userJourney
			vsnFeeTokenCollection {
				globalOptIn
				enabled
				eligibleForVsn
				feeDiscount
				feeDiscountBefore
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class EstimateOrderGQLService extends Apollo.Query<EstimateOrderQuery, EstimateOrderQueryVariables> {
	document = EstimateOrderDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
